// extracted by mini-css-extract-plugin
export default {"wrapper":"Badge_wrapper__DREIN"};